let env = {};
for(let prop in process.env) {
    env[prop.replace('REACT_APP_','')] = process.env[prop];
}
export default env;